import * as types from '../actions/actionTypes';
const Avatars = [
  '654348a084461e994dfa00a3',
  '65434d5dc91bc66cf7de81ae',
  '65434eeecc14c7b0c462cbee',
  '654a373b29a531c3e468283e',
  '654c7d15cb89ba26398ed220',
  '654c7c9bbb3be6ab35d27193',
  '655db2f9e88a425143910559',
  '655db273e88a4251439103da',
  '655de1cebb39d3a4464c1121',
  '65f7c5872cebbb1755b5d287',
  '654e09029b792809cd8a5762',
  '655b4ca11b3c8f493518a60d',
];

const randomItem = Avatars[Math.floor(Math.random() * Avatars.length)];

export const initialState = {
  direct_landing: false,
  joinMeetingStatus: false,
  avatarUrlValue: `https://models.readyplayer.me/${randomItem}.glb`,
  ready_to_move: false,
  // True once a lesson has been started via start_lesson; used to gate transcript/panel UI
  lessonStarted: false,
  // True if lesson is currently paused (false = playing, true = paused)
  lessonPaused: false,
  // True once Unity has reported rpmReady for the current world/avatar
  rpmReady: false,
  showLeaveConfirmationModal: false,
  courseLeaveConfigs: {
    message: 'Are you sure you want to teleport to Quikbase?',
    portalType: 'exit_portal',
  },
  // Lesson transcript / panel controls – Unity will drive these values via bridge messages
  lessonControls: {
    buttonVisibility: {
      next: true,
      previous: true,
      // Pause visible by default, resume hidden – Unity will toggle these
      pause: true,
      resume: false,
    },
    buttonInteraction: {
      // As per Unity contract, all start non-interactable
      next: false,
      previous: false,
      pause: false,
      resume: false,
    },
    // Lesson piece text to render in a transcript panel
    lessonText: '',
  },
  // Cache last known lesson piece text per lessonId so UI can recover if Unity doesn't re-emit
  // immediately when restarting the same lesson (common on web).
  lessonTextByLessonId: {},
  legacy: true,
  isQuikbase: false,
  customCourse: false,
};

const updateState = (state = initialState, action) => {
  switch (action.type) {
    case types.JOIN_MEETING: {
      return {...state, joinMeetingStatus: action.payload};
    }
    case types.SET_AVATAR_URL: {
      return {...state, avatarUrlValue: action.payload};
    }
    case types.SET_DIRECT_LANDING: {
      return {...state, direct_landing: action.payload};
    }
    case types.SET_READY_TO_MOVE: {
      return {...state, ready_to_move: action.payload};
    }
    case types.SET_LESSON_STARTED: {
      return {...state, lessonStarted: Boolean(action.payload)};
    }
    case types.SET_LESSON_PAUSED: {
      return {...state, lessonPaused: Boolean(action.payload)};
    }
    case types.SET_RPM_READY: {
      return {...state, rpmReady: Boolean(action.payload)};
    }
    case types.SET_SHOW_LEAVE_CONFIRMATION_MODAL: {
      return {...state, showLeaveConfirmationModal: action.payload};
    }
    case types.SET_COURSE_LEAVE_CONFIGS: {
      return {...state, courseLeaveConfigs: action.payload};
    }
    case types.SET_LESSON_BUTTON_VISIBILITY: {
      const {buttonType, visible} = action.payload || {};
      const key = (buttonType || '').toLowerCase();
      if (!['next', 'previous', 'pause', 'resume'].includes(key)) {
        return state;
      }

      // Per design, next/previous are always visible regardless of Unity flag
      const effectiveVisible =
        key === 'next' || key === 'previous' ? true : Boolean(visible);

      return {
        ...state,
        lessonControls: {
          ...state.lessonControls,
          buttonVisibility: {
            ...state.lessonControls.buttonVisibility,
            [key]: effectiveVisible,
          },
        },
      };
    }
    case types.SET_LESSON_BUTTON_INTERACTION: {
      const {buttonType, interactable} = action.payload || {};
      const key = (buttonType || '').toLowerCase();
      if (!['next', 'previous', 'pause', 'resume'].includes(key)) {
        return state;
      }

      // Treat pause and resume interaction as a single shared state.
      if (key === 'pause' || key === 'resume') {
        const enabled = Boolean(interactable);
        return {
          ...state,
          lessonControls: {
            ...state.lessonControls,
            buttonInteraction: {
              ...state.lessonControls.buttonInteraction,
              pause: enabled,
              resume: enabled,
            },
          },
        };
      }

      return {
        ...state,
        lessonControls: {
          ...state.lessonControls,
          buttonInteraction: {
            ...state.lessonControls.buttonInteraction,
            [key]: Boolean(interactable),
          },
        },
      };
    }
    case types.RESET_LESSON_BUTTON_INTERACTION: {
      return {
        ...state,
        lessonControls: {
          ...state.lessonControls,
          buttonInteraction: {
            next: false,
            previous: false,
            pause: false,
            resume: false,
          },
        },
      };
    }
    case types.SET_LESSON_PIECE_TEXT: {
      const text = (action.payload && action.payload.text) || '';
      const lessonId = (action.payload && action.payload.lessonId) || '';
      const shouldCache =
        Boolean(lessonId) && Boolean(String(text || '').trim().length);
      return {
        ...state,
        lessonTextByLessonId: shouldCache
          ? {
              ...(state.lessonTextByLessonId || {}),
              [lessonId]: text,
            }
          : state.lessonTextByLessonId,
        lessonControls: {
          ...state.lessonControls,
          lessonText: text,
        },
      };
    }
    case types.SET_LEGACY_FLAG: {
      return {...state, legacy: action.payload};
    }
    case types.SET_IS_QUIKBASE: {
      return {...state, isQuikbase: action.payload};
    }
    case types.SET_CUSTOM_COURSE: {
      return {...state, customCourse: action.payload};
    }
    case types.SET_LESSON_CONTROLS: {
      return {...state, lessonControls: {...state.lessonControls, ...action.payload}};
    }
    default:
      return state;
  }
};

export default updateState;
